import { React, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { updateAddress, updateThirdParty } from '../actions'
import { Typography, Paper, FormControlLabel, Checkbox, Button, IconButton } from '@mui/material'
import Grid from '@mui/material/Grid';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import NavigationButtons from '../container/NavigationButtons';
import Person from './custom/Person';
import Address from './custom/Address';
import ReactTooltip from 'react-tooltip';

const StyledReactTooltip = styled(ReactTooltip)({
  width: 300,
  maxWidth: '40%',
});

function ThirdPartyInformation(props) {
  const dispatch = useDispatch()
  const start = useSelector((state) => state.start)
  // const person = useSelector((state) => state.thirdparty)
  // const addresses = useSelector((state) => state.addresses)
  const initialPerson = useSelector((state) => state.thirdparty)
  const initialAddresses = useSelector((state) => state.addresses)

  const [person, setPerson] = useState(initialPerson);
  const [addresses, setAddresses] = useState(initialAddresses)
  const [Q, setQ] = useState('')
  const [location, setLocation] = useState('Permanent Address in United States or Abroad')
  // const [countries, setCountries] = useState([]);
  const [business, setBusiness] = useState(false);
  // const [thirdpartylocator, setThirdpartylocator] = useState('');

  const [requiredFields, setRequiredFields] = useState({person: false, address2: false, locator:props.locator});

  useEffect(() => {
    setPerson(initialPerson)
  }, [initialPerson])
  useEffect(() => {
    setAddresses(initialAddresses)
  }, [initialAddresses])
  

  // constructor(props) {
  //   super(props);    
  //   this.state = {Q: '', location: 'Permanent Address in United States or Abroad', start: props.start, activeStep: props.activeStep, countries: [],
  //                   person: props.person, addresses: props.addresses, business: false, thirdpartylocator:'',
  //                   requiredFields: {person: false, address2: false, locator:props.locator}};
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props !== nextProps) {
  //     const { start, person, addresses } = this.state
          
  //     if (nextProps.start !== start) {
  //       this.setState({ start: nextProps.start });
  //     }

  //     if (nextProps.person !== person) {
  //       this.setState({ person: nextProps.person });
  //     }
  //     if (nextProps.addresses !== addresses) {
  //       this.setState({ addresses: nextProps.addresses });
  //     }
  //   }
  // }

  const updatePerson = (person) => {
    // this.setState({ person: person });
    setPerson(person)
    // dispatch( updateThirdParty(person) )
  } 

  const updateAddresses = (address, index) =>  {
    const newAddresses = {...addresses}

    newAddresses[index] = address      

    // this.setState({ addresses: newAddresses });
    setAddresses(newAddresses)
    // dispatch( updateAddress(newAddresses) )      
  }

  const handleError = (propertyName, allReqDone) => {
    const newRequiredFields = {
      ...requiredFields,
      [propertyName]: allReqDone,      
    };    
    
    setRequiredFields(newRequiredFields)
  }

  const handleChangeChecked = propertyName => event => {
    if (propertyName === 'BU') {
      setBusiness(event.target.checked)
    } else {
      const newPerson = {
        ...person,
        isBank: event.target.checked
      }
      setPerson(newPerson)
      // this.setState({ person: newPerson });
      // dispatch( updateThirdParty(newPerson) )
    }
  }

  const selectPCT = (selection) => {
    setQ(selection)
    if (selection === 'Q4') {
      setLocation('Address of the Pick up Location')
    } else if (selection === 'Q3' || selection === 'Q1') {
      setLocation('Business Address of the Shipper')
    } else if (selection === 'Q2') {
      setLocation('Address of the Currency Originator')
    }
  }

  return (
    <div>       
          <Paper sx={{
            m: 2,
            p: 2,
            textAlign: 'left',
            justifyContent: 'center',
            color: 'text.primary',
            backgroundColor: '#ffffff',
          }}>

          {(start.pct === 'Y' && Q === '') &&  
          <Grid>
            <Typography sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '2px',
              color: '#000000'
            }} align='center'>Does the Currency or Monetary Instrument belong to the Shipper or Currency Originator?
            <span data-tip="" data-for='currTrans'>                  
                <IconButton aria-label="Info">
                  <InfoIcon sx={{
                    verticalAlign: 'text-top',
                    color: '#3939c8',
                    pt: '0px',
                    pb: '12px',
                  }} />
                </IconButton> </span>
                <StyledReactTooltip id='currTrans'>
                  {"The actual address location of business where the currency is picked up from."}
                </StyledReactTooltip>
            </Typography>              
            <Grid container sx={{ justifyContent: "center" }}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                m: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Q1')} >
                Shipper
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                m: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Q2')} >
                Currency Originator
              </Button>
            </Grid>
          </Grid>
          }
            {(start.pct === 'Y' && Q === 'Q1') &&  
          <Grid>
            <Typography sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '2px',
              color: '#000000'
            }} align='center'>Where is the Currency or Monetary Instrument being picked up from?
            <span data-tip="" data-for='currTrans'>                  
                <IconButton aria-label="Info">
                  <InfoIcon sx={{
                    verticalAlign: 'text-top',
                    color: '#3939c8',
                    pt: '0px',
                    pb: '12px',
                  }} />
                </IconButton> </span>
                <StyledReactTooltip id='currTrans'>
                  {"The actual address location of business where the currency is picked up from."}
                </StyledReactTooltip>
            </Typography>              
            <Grid container sx={{ justifyContent: "center" }}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                m: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Q3')} >
                Shipper's Place of Business
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                m: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Q4')} >
                Different Pick up Location
              </Button>
            </Grid>
          </Grid>
          }

          {(start.pct === 'N' || Q === 'Q2' || Q === 'Q3' || Q === 'Q4') &&
            <Grid>
              <FormControlLabel
                sx={{ ml: '0px' }}
                control={
                <Checkbox
                  checked={business ? true: false}
                  onChange={handleChangeChecked('BU')}
                  value={business}
                /> }
                label="Business"
              />

              {business && 
              <FormControlLabel
                sx={{ ml: '0px' }}
                control={
                <Checkbox
                  checked={person.isBank ? true: false}
                  onChange={handleChangeChecked('BA')}
                  value={person.isBank}
                /> }
                label="Business is Bank"
              />
              }

              <Person person={person} thirdpartylocator='thirdparty' updatePerson={updatePerson} handleError={handleError} thirdParty={true}
                    business={business} />
                            
              <Grid>
                <Typography sx={{
                  mr: 2,
                  fontSize: '0.9375rem',
                  color: 'text.primary',
                  pt: '32px',
                  mb: '0px',
                  fontWeight: "660"
                }}>{location}</Typography>
              </Grid>

              <Address address={addresses[2]} index='2' thirdpartylocator='thirdparty' updateAddress={updateAddresses} handleError={handleError} />                

              <NavigationButtons thirdparty={person} addresses={addresses} 
                        allReqDone={requiredFields.person && requiredFields.address2} />
            </Grid>
            }            
        </Paper>
      </div>
  );
}

export default ThirdPartyInformation;